<template>
    <div class="col-12 mx-auto">
        <div>
            <div class="card">
                <dashboard-ctrl :componentName="componentName"
                                :showHideButton="false"
                                :showPinButton="false"
                                :showResizeIcon="false"
                                :headerTitle="titleKey"
                                :showHeadful="showHeadful"
                                :componentClass="'card-header bg-primary text-white'">
                </dashboard-ctrl>

                <div class="card-header">
                    <button type="button" class="btn btn-primary btn-lg"
                            v-if="hasCreateRights"
                            @click="createBtnClick">
                        {{$t('buttons.create.btnText')}}
                    </button>
                </div>

                <div class="btn-toolbar justify-content-between mb-0 mt-2" role="toolbar">
                    <div class="col-w">

                    </div>
                    <div class="input-group">
                        <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

                <div class="card-body" id="grid">
                    <kendo-datasource ref="datasource1"
                                      :transport="transportSettings"
                                      :schema-model-id="'id'"
                                      :schema-model-fields="schemaModelFields"
                                      :schema-total="'total'"
                                      :schema-data="'data'"
                                      :page-size='gridOptions.pageable.size'
                                      :server-paging="true"
                                      :server-sorting="true"
                                      :server-filtering="true"
                                      :error="dataSourceError"
                                      :requestEnd="datasorceRequestEnd">
                    </kendo-datasource>

                    <kendo-grid ref="grid"
                                :data-source-ref="'datasource1'"
                                :pageable="gridOptions.pageable"
                                :navigatable="gridOptions.navigatable"
                                :editable="gridOptions.editable"
                                :filterable="gridOptions.filterable"
                                :reorderable="gridOptions.reorderable"
                                :resizable="gridOptions.resizable"
                                :groupable="gridOptions.groupable"
                                :allow-copy="gridOptions.allowCopy"
                                :column-menu="gridOptions.columnMenu"
                                :sortable-mode="gridOptions.sortable.mode"
                                :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                                :sortable-show-indexes="gridOptions.sortable.showIndexes"
                                :selectable="gridOptions.selectable"
                                :scrollable="gridOptions.scrollable"
                                :toolbar="toolbar"
                                :excel="gridOptions.excel"
                                :pdf="gridOptions.pdf"
                                :data-bound="dataBound">
                        <kendo-grid-column v-if="showBtns"
                                           field="btnsColumn"
                                           :title="$t('actions')"
                                           :sortable="false"
                                           :filterable="false"
                                           :template="btnsTemplate"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'name'"
                                           :title="$t('registers.forms.gridHeaders.name')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'nameEn'"
                                           :title="$t('registers.forms.gridHeaders.nameEn')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="!isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'formType'"
                                           :title="$t('registers.forms.gridHeaders.formType')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'formTypeEn'"
                                           :title="$t('registers.forms.gridHeaders.formTypeEn')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false"
                                           :hidden="!isEnVersion">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'note'"
                                           :title="$t('registers.forms.gridHeaders.note')"
                                           :width="200"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'deactivated'"
                                           :title="$t('registers.forms.gridHeaders.deactivated')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :template="deactivatedCellTemplate">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'creatorUsername'"
                                           :title="$t('registers.forms.gridHeaders.creatorUsername')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'createdAtUtc'"
                                           :title="$t('registers.forms.gridHeaders.createdAtUtc')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :format="'{0:dd-MM-yyyy HH:mm:ss}'">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'updaterUsername'"
                                           :title="$t('registers.forms.gridHeaders.updaterUsername')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'updatedAtUtc'"
                                           :title="$t('registers.forms.gridHeaders.updatedAtUtc')"
                                           :width="150"
                                           :lockable="true"
                                           :locked="false"
                                           :format="'{0:dd-MM-yyyy HH:mm:ss}'">
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>

    </div>

</template>

<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import ControlBtnsTemplate from "../../components/dashboard/ControlBtnsTemplate";
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import formSurverService from '../../services/formSurvey.service';

    /*
    Renders the grid in "DejaVu Sans" font family, which is
    declared in kendo.common.css. It also declares the paths to the
    fonts below using <tt>kendo.pdf.defineFont</tt>, because the
    stylesheet is hosted on a different domain.
    */
    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });

    export default {
        name: 'forms-template-grid',
        components: {
            'dashboard-ctrl': ControlBtnsTemplate,
        },
        created: function () {
            window.JSZip = JSZip
        },
        props: {
            showBtns: {
                default: true,
                type: Boolean
            },
            returnUrl: {
                type: String,
                default: ''
            },
            showHeadful: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                componentName: "FormsTemplatesListGrid",
                titleKey: 'registers.forms.templates',
                searchQuery: '',
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true, titleKey: 'registers.forms.gridHeaders.id' },
                    name: { name: 'name', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.name' },
                    nameEn: { name: 'nameEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.nameEn' },
                    formType: { name: 'formType', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formType' },
                    formTypeEn: { name: 'formTypeEn', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.formTypeEn' },
                    note: { name: 'note', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.note' },
                    isTemplate: { name: 'isTemplate', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'registers.forms.gridHeaders.isTemplate' },
                    deactivated: { name: 'deactivated', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'registers.forms.gridHeaders.deactivated' },
                    creatorUsername: { name: 'creatorUsername', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.creatorUsername' },
                    createdAtUtc: { name: 'createdAtUtc', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.createdAtUtc' },
                    updaterUsername: { name: 'updaterUsername', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.updaterUsername' },
                    updatedAtUtc: { name: 'createdAtUtc', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.updatedAtUtc' }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/dynamicForms/listTemplates',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    excel: {
                        fileName: 'FormsTemplates.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'FormsTemplates.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                working: false,
                showUserSettingsForm: false,
            }
        },
        methods: {
            dataBound(e) {
                // if (!this.customSettingsLoaded) {
                //     this.customSettingsLoaded = true;
                //     this.loadGridSettings();
                // }
            },
            dataSourceError(e) {
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.kendoDataSourceErrorText(e),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration,
                    });
                },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    return kendo.stringify(options);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            datasorceRequestEnd(e) {

            },
            deactivatedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.deactivated ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [{
                            name: "edit",
                            text: this.$t('buttons.edit.btnText'),
                            tooltip: this.$t('buttons.edit.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-edit",
                            show: this.hasEditRights,
                            clickHandler: this.editBtnClick
                        },
                        {
                            name: "copy",
                            text: '',
                            tooltip: this.$t('buttons.copy.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-copy",
                            show: this.hasCreateRights,
                            clickHandler: this.copyBtnClick
                        },
                        {
                            name: "details",
                            text: this.$t('buttons.details.btnText'),
                            tooltip: this.$t('buttons.details.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-info-circle",
                            show: true,
                            clickHandler: this.detailsBtnClick
                        },
                        {
                            name: "deactivation",
                            text: this.$t('buttons.deactivate.btnText'),
                            tooltip: this.$t('buttons.deactivate.btnText'),
                            class: 'btn btn-danger',
                            icon: "fas fa-lock",
                            show: this.hasDeleteRights && !e.deactivated,
                            clickHandler: this.deactivateBtnClick
                        }, {
                            name: 'activation',
                            text: this.$t('buttons.activate.btnText'),
                            tooltip: this.$t('buttons.activate.btnText'),
                            class: 'btn btn-success',
                            icon: "fas fa-lock-open",
                            show: this.hasDeleteRights && e.deactivated,
                            clickHandler: this.activateBtnClick
                        },
                        {
                            name: 'deletion',
                            text: this.$t('buttons.delete.btnText'),
                            tooltip: this.$t('buttons.delete.btnText'),
                            class: 'btn btn-success',
                            icon: "fas fa-times",
                            show: this.hasDeleteRights,
                            clickHandler: this.deleteBtnClick
                        }
                        ]
                    }
                };
            },
            copyBtnClick(args) {
                if (!this.hasCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'copyForm', query: { id: args.formId, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            createBtnClick: function () {
                if (!this.hasCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'createForm', query: { relatedId: this.relatedEventId, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            editBtnClick: function (args) {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'editForm', query: { id: args.formId, returnUrl: this.returnUrl} });
                window.open(routeData.href, '_blank');
            },
            detailsBtnClick: function (args) {
                if (!this.hasReadRights) {
                    return this.$router.push(`/unauthorized`);
                }

                let routeData = this.$router.resolve({ name: 'formDetails', query: { id: args.formId, returnUrl: this.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            deactivateBtnClick(args) {
                if (!this.hasEditRights) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                if (args.deactivated) {
                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$t('buttons.deactivate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;
                this.$http.delete('/api/dynamicForms/deactivate',
                    { params: { id: args.id } }
                ).then((response) => {
                    this.$refs.grid.kendoWidget().dataSource.read();

                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            activateBtnClick(args) {
                if (!this.hasEditRights) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                if (!args.deactivated) {
                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: this.$t('buttons.activate.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                this.working = true;

                this.$http.delete('/api/dynamicForms/activate',
                    { params: { id: args.id } }
                ).then((response) => {
                    this.$refs.grid.kendoWidget().dataSource.read();

                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: response.message ? response.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })

                this.working = false;
            },
            deleteBtnClick(args) {
                if (!this.hasEditRights) {
                    this.$router.push(`/unauthorized`);
                    return;
                }

                if (args.deleted) {
                    this.$vs.notify({
                        title: this.$t('buttons.deleted.action'),
                        text: this.$t('buttons.deleted.already'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration,
                    })

                    return;
                }

                 kendo.confirm(`${this.$t('buttons.delete.confirmationText')}`)
                    .then(function () {
                        this.doDelete(args.id)
                    }.bind(this));
            },
            doDelete(id){
                this.working = true;
                formSurverService
                    .deleteForm(id)
                    .then(response => {
                        this.refresh()

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => { this.working = false; });
            },
            refresh() {
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        mounted() {

        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
            hasCreateRights() {
                return this.$store.getters.claims.dynamicRegister.create;
            },
            hasEditRights() {
                return this.$store.getters.claims.dynamicRegister.update;
            },
            hasReadRights() {
                return this.$store.getters.claims.dynamicRegister.read;
            },
            hasDeleteRights() {
                return this.$store.getters.claims.dynamicRegister.delete;
            }
        }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: "DejaVu Sans", "Arial", sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit, .k-grid-details, .k-grid-delete, .k-grid-pdf, .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
